export const formatDateToBr = (date) => {
  try {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Aqui você mantém o -03:00 ou outro offset fixo que deseja aplicar
    const offset = "-03:00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;
  } catch {
    console.error("Erro no formatDatetoBr", date);
  }
  // Retorna a data formatada no padrão YYYY-MM-DDTHH:MM:SS-03:00
};
